import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

interface LogoProps {
  /** "icon" = square mark only, "wordmark" = text only, "full" = icon + wordmark */
  variant?: "icon" | "wordmark" | "full";
  className?: string;
  height?: number;
}

export function Logo({ variant = "full", className = "", height = 32 }: LogoProps) {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  // Avoid hydration mismatch — render nothing until theme is known
  if (!mounted) return <div style={{ height }} className={className} />;

  const isDark = resolvedTheme === "dark";

  const src = {
    icon: isDark ? "/brand-icon-light.svg" : "/brand-icon-dark.svg",
    wordmark: isDark ? "/brand-wordmark-light.svg" : "/brand-wordmark-dark.svg",
    full: isDark ? "/brand-logo-light.svg" : "/brand-logo-dark.svg",
  }[variant];

  const aspectRatios = { icon: 1, wordmark: 480 / 88, full: 616 / 116 };
  const width = Math.round(height * aspectRatios[variant]);

  return (
    <img
      src={src}
      alt="Peersheep"
      height={height}
      width={width}
      className={className}
      draggable={false}
    />
  );
}
